import { FileXls } from "@phosphor-icons/react";
import { STATUS_LABELS } from "@/lib/api";
import KanbanCard from "./KanbanCard";

export default function KanbanColumn({
  status, colIdx, lastIdx, full, visibleCount, totalInCol,
  selectionMode, canAdmin, selectedIds, exporting, draggingId, highlightId,
  onDragOver, onDrop, onToggleColumn, onExportCol, onShowMore,
  onCardClick, onCardToggle, onCardDragStart, onCardDragEnd, onArrowMove,
}) {
  const shown = full.slice(0, visibleCount);
  const remaining = Math.max(totalInCol, full.length) - shown.length;

  return (
    <div
      className="kanban-col w-[240px] shrink-0"
      onDragOver={onDragOver}
      onDrop={() => onDrop(status)}
      data-testid={`kanban-col-${status}`}
    >
      <div className="kanban-col-header flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className={`dot ${status}`} />
          <span className="overline">{STATUS_LABELS[status]}</span>
        </div>
        <div className="flex items-center gap-1.5">
          {selectionMode && canAdmin && shown.length > 0 && (
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); onToggleColumn(full); }}
              className="text-[9px] font-bold uppercase tracking-widest border border-black px-1.5 py-0.5 hover:bg-black hover:text-white"
              data-testid={`kanban-select-col-${status}`}
              title={`Marca ou desmarca TODOS os ${full.length} cartões desta coluna (inclui os não exibidos)`}
            >
              Todos ({full.length})
            </button>
          )}
          {(status !== "em_desenvolvimento" || canAdmin) && (
            <span className="font-mono text-sm font-bold" data-testid={`kanban-count-${status}`}>{totalInCol}</span>
          )}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onExportCol(status); }}
            disabled={!!exporting}
            className="text-zinc-400 hover:text-black disabled:opacity-40"
            data-testid={`kanban-export-col-${status}`}
            title={`Exportar a coluna "${STATUS_LABELS[status]}" para Excel com todos os dados dos pedidos`}
          >
            <FileXls size={15} weight={exporting === status ? "fill" : "bold"} />
          </button>
        </div>
      </div>
      <div className="flex-1 kanban-col-body" data-testid="kanban-col-body">
        {shown.map((o) => (
          <KanbanCard
            key={o.id}
            o={o}
            canAdmin={canAdmin}
            selectionMode={selectionMode}
            isSelected={selectedIds.has(o.id)}
            isDragging={draggingId === o.id}
            isHighlighted={highlightId === o.id}
            canGoBack={colIdx > 0}
            canGoForward={colIdx < lastIdx}
            onDragStart={onCardDragStart}
            onDragEnd={onCardDragEnd}
            onClick={onCardClick}
            onToggleSelect={onCardToggle}
            onArrowMove={onArrowMove}
          />
        ))}
        {full.length === 0 && (
          <div className="text-center text-zinc-300 text-xs py-10">vazio</div>
        )}
        {remaining > 0 && (
          <button
            className="w-full py-3 border border-dashed border-zinc-400 text-xs font-bold uppercase tracking-widest hover:bg-black hover:text-white hover:border-black transition-colors my-2"
            onClick={() => onShowMore(status)}
            data-testid={`show-more-${status}`}
          >
            Mostrar mais ({remaining} restantes)
          </button>
        )}
      </div>
    </div>
  );
}
